<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :isHome="false" title="ROON Mining"></home-nav>
		</template>
		<template v-slot:content>
			<div class="pb-140 px-30">
				<div class="w-690 h-240 rounded-20 p-30 roon-mining-banner-bg-image">
					<div class="">
						<span class="text-36 text-white">USDR - ROON</span>
						<span class="ml-20 text-white text-36">{{$t("ROONMining.LP池")}}</span>
					</div>
					<div class="mt-20">
						<span class="text-24 text-#ccc">{{$t("ROONMining.我的流动性")}}</span>
					</div>
					<div class="mt-20">
						<span class="text-50 text-white font-bold">{{lp_token}}</span>
					</div>
				</div>
				<div class="mt-20 rounded-20 p-30" style="background-color: #19191A;">
					<div class="flex items-center justify-between">
						<div class="">
							<span class="text-36 text-white">{{$t("ROONMining.我的LP数据")}}</span>
						</div>
						<div class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
							style="border-color:#9646FF; background-color: #9646FF20;">
							<span class="text-20" style="color: #9646FF;">{{lp_vip_name}}</span>
						</div>
					</div>
					<div  class="mt-20 flex items-center justify-between">
						<div class="roon-mining-item4-bg-image p-24">
							<div class="">
								<span class="text-20 text-#999">{{$t("ROONMining.我的LP")}}</span>
							</div>
							<div class="mt-16">
								<span class="text-28 text-#9646FF font-bold">{{lp_token}}</span>
							</div>
						</div>
						<div class="roon-mining-item4-bg-image p-24">
							<div class="">
								<span class="text-20 text-#999">{{$t("ROONMining.累计收益")}}</span>
							</div>
							<div class="mt-16">
								<span class="text-28 text-primary font-bold">{{staticnumber}}  ROON</span>
							</div>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<div class="roon-mining-item4-bg-image p-24">
							<div class="">
                            <span class="text-20 text-#999">{{$t("ROONMining.总本金")}}</span>
							</div>
							<div class="mt-16">
								<span class="text-28 text-success font-bold">{{principal}} USDR</span>
							</div>
						</div>
						<div class="roon-mining-item4-bg-image p-24">
							<div class="">
								<span class="text-20 text-#999">{{$t("ROONMining.推荐收益")}}</span>
							</div>
							<div class="mt-16">
								<span class="text-28 text-primary font-bold">{{team_bouns}}  ROON</span>
							</div>
						</div>
					</div>

                    <div class="mt-20 flex items-center justify-between">
                        <div class="roon-mining-item4-bg-image p-24" style="height: 160rem;">
                            <div class="">
                                <span class="text-20 text-#999">USDR余额</span>
                            </div>
                            <div class="mt-16">
                                <span class="text-28 text-success font-bold">{{usdr_balance}} USDR</span>
                            </div>
                            <div class="mt-10 flex items-center">
                                <div class="px-20 h-50 rounded-12 flex items-center justify-center" style="background-color: #3C7BFF;" @click.stop="handleDetail('usdr_balance')">
                                    <span class="text-24 text-white">{{$t('ROONMining.明细')}}</span>
                                </div>
                                <div class="ml-10 px-20 h-50 rounded-12 flex items-center justify-center" style="background-color: #9646FF;" @click.stop="handleWithdraw('USDR')">
                                    <span class="text-24 text-white">{{$t('ROONMining.提现')}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="roon-mining-item4-bg-image p-24" style="height: 160rem;">
                            <div class="">
                                <span class="text-20 text-#999">ROON余额</span>
                            </div>
                            <div class="mt-16">
                                <span class="text-28 text-primary font-bold">{{roon_balance}}  ROON</span>
                            </div>
                            <div class="mt-10 flex items-center">
                                <div class="px-20 h-50 rounded-12 flex items-center justify-center" style="background-color: #3C7BFF;" @click.stop="handleDetail('roon_balance')">
                                    <span class="text-24 text-white">{{$t('ROONMining.明细')}}</span>
                                </div>
                                <div class="ml-10 px-20 h-50 rounded-12 flex items-center justify-center" style="background-color: #9646FF;" @click.stop="handleWithdraw('ROON')">
                                    <span class="text-24 text-white">{{$t('ROONMining.提现')}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
				<div class="mt-26 flex items-center justify-between">
					<div @click="goToAddLp" class="w-336 h-240 rounded-20 p-30 roon-mining-item1-bg-image">
						<div>
							<img class="w-80 h-80" src="@/assets/images/pages/roon-mining/add.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-32 text-white">{{$t("ROONMining.添加LP")}}</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#eee">USDR + ROON</span>
						</div>
					</div>
					<div @click="goToMyLp" class="w-336 h-240 rounded-20 p-30 roon-mining-item2-bg-image">
						<div>
							<img class="w-80 h-80" src="@/assets/images/pages/roon-mining/qb.png" alt="" />
						</div>
						<div class="mt-20">
							<span class="text-32 text-white">{{$t("ROONMining.我的LP")}}</span>
						</div>
						<div class="mt-20">
							<span class="text-20 text-#eee">{{$t("ROONMining.查看详情")}}</span>
						</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
					<div class="">
						<span class="text-white text-36">{{$t("ROONMining.更多功能")}}</span>
					</div>
					<div @click="goToRecommenderSystem" class="mt-20 roon-mining-item3-bg-image rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/roon-mining/gn1.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("ROONMining.推荐系统")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("ROONMining.直推10%收益")}}</span>
							</div>
						</div>
					</div>
					<div @click="goToDividendPool" class="mt-20 roon-mining-item3-bg-image rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/roon-mining/gn2.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("ROONMining.分红池")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("ROONMining.多重收益分配")}}</span>
							</div>
						</div>
					</div>
					<div @click="goToNft" class="mt-20 roon-mining-item3-bg-image rounded-20 flex items-center p-20">
						<div class="w-70 h-70">
							<img class="w-full h-full" src="@/assets/images/pages/roon-mining/gn3.png" alt="" />
						</div>
						<div class="ml-20">
							<div>
								<span class="text-24 text-white">{{$t("ROONMining.NFT权益")}}</span>
							</div>
							<div class="mt-10">
								<span class="text-20 text-#999">{{$t("ROONMining.节点与矿机")}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-20 bg-white/10 rounded-20 p-30" style="background-color: #19191A;">
					<div class="">
						<span class="text-white text-36">{{$t("ROONMining.挖矿规则")}}</span>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-30">
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("ROONMining.20天为一个周期,中间不可撤出LP")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("ROONMining.LP每个钱包地址最多添加一次LP")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("ROONMining.每个LP每天收益1个ROON")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("ROONMining.20天到期:本金+20个ROON")}}</span>
						</div>
						<div class="py-10 flex items-center">
							<div class="bg-#5ACC3C w-10 h-10 rounded-full"></div>
							<span class="ml-20 text-24 text-#ccc">{{$t("ROONMining.保障本金+利息,不受价格波动影响")}}</span>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="home"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<!-- 设置上级弹窗  closeable -->
			<!-- <van-popup v-model="managerShow" round :style="{ width: '600rem', backgroundColor: '#09242C' }">
				<div class="flex items-center justify-center py-3">
					<span class="text-primary font-bold" style="font-size: 36rem;">{{ $t('弹窗.上级邀请码') }}</span>
				</div>
				<div class="flex items-center rounded-full my-4 mx-3 px-3"
					style="height: 100rem; background-color: rgba(245, 245, 245, .1);">
					<input class=" flex-1 text-white" style="font-size: 28rem;" type="text" v-model="invite"
						:placeholder="$t('弹窗.请输入邀请码')" />
				</div>
				<div class="flex items-center justify-center pb-4">
					<div class="flex items-center justify-center rounded-30 airdrop-item-btn-image mt-4 mx-3"
						@click="changeManager">
						<span class="text-32 font-bold">{{ $t('弹窗.确认') }}</span>
					</div>
				</div>
			</van-popup> -->

            <van-popup v-model="showAmountPopup" position="center" round>
                 <div class="w-690">
                     <div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30 px-30" style="margin-top: -98rem;">
                         <div class="flex items-center justify-between mt-20">
                             <span v-if="form.type == 1" class="text-36 text-white">USDR{{$t("USDR闪兑.提现")}}</span>
                             <span v-else class="text-36 text-white">ROON{{$t("USDR闪兑.提现")}}</span>
                             <img @click="showAmountPopup = false" class="w-40 h-40" src="@/assets/images/pages/usdr-swap/icon_gb.png" alt="" />
                         </div>
                         <div class="flex items-center mt-20">
                             <span class="text-26 text-#999">{{$t("USDR闪兑.可用余额")}}</span>
                             <span class="text-26 text-primary ml-20" v-if="form.type == 1">{{usdr_balance}}</span>
                             <span class="text-26 text-primary ml-20" v-else>{{roon_balance}}</span>
                         </div>
                         <div class="mt-20">
                             <span class="text-26 text-#999">{{$t("USDR闪兑.提现数量")}}</span>
                         </div>
                         <div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">
                             <input class="flex-1 text-32 text-white" v-model="withdrawal_number" @input="handleWithdrawalInput" type="text" inputmode="decimal" :placeholder="$t('USDR闪兑.请输入数量')" />
                             <img v-if="form.type == 1" class="w-50 h-50" src="@/assets/images/common/icon_usdr.png" alt="" />
                             <img v-else class="w-50 h-50" src="@/assets/images/pages/swap/roon.png" alt="" />
                         </div>
 <!-- 	 	 	 	 	 	 <div class="mt-20">-->
 <!-- 	 	 	 	 	 	 	 <span class="text-26 text-#999">{{$t("USDR闪兑.提现地址")}}</span>-->
 <!-- 	 	 	 	 	 	 </div>-->
 <!-- 	 	 	 	 	 	 <div class="h-110 rounded-18 bg-#1B1B1B flex items-center justify-between mt-20 mx-20 px-30">-->
 <!-- 	 	 	 	 	 	 	 <input class="flex-1 text-32 text-white" type="text" :placeholder="$t('USDR闪兑.输入钱包地址')" />-->
 <!-- 	 	 	 	 	 	 </div>-->
                         <div class="mt-40 flex items-center justify-center">
                             <div @click="withdrawal" class="w-630 h-100 bg-primary rounded-full flex items-center justify-center">
                                 <span class="text-32 text-white">{{$t('闪兑.确认')}}</span>
                             </div>
                         </div>
                     </div>
                 </div>
             </van-popup>

            <!-- 不可关闭的 Loading 遮罩：发起兑换接口后显示，接口有响应则关闭 -->
            <van-overlay :show="swapping" :z-index="100000" lock-scroll>
                <div class="w-full h-full flex items-center justify-center">
                    <div class="px-40 py-30 bg-#1B1B1B rounded-20 flex items-center">
                        <van-loading type="spinner" color="#EB470C" size="28px" />
                        <span class="ml-16 text-28 text-white">Loading…</span>
                    </div>
                </div>
            </van-overlay>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import {
		getShowAddress,
		getToken,
		setShowAddress,
		setToken
	} from "@/libs/util";
	import Web3 from "web3";
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";

	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
                withdrawal_roon_number: "0.002",
				pool_total: 0,
				pool_release: 0,
				pool_destroy: 0,
				parent_id: 0,
                team_bouns: 0,
				total_pledge: 0,
				dynamic_bouns: 0,
                usdr_balance: 0,
                roon_balance: 0,
                lp_token: 0,
				state_bouns: 0,
				state_bouns_today: 0,
				team_one: 0,
                staticnumber: 0,
                principal: 0,
				team_four: 0,
				tvl: "",
				mua: "",
                lp_vip_name: "",
				address: "",
				manager: "",
				timer: null,
				web3Provider: null,
				web3: null,
				banner: [{}, {}, {}],
                chains: [],
				currency: [],
				stocks: [],
				rotation: [],
				new_title: "",
                show_address: "",
				new_id: "",
				next_vip_name: "",
				next_vip_number: "",
				last_update_time: "",
				invite: "",
				// 设置上级弹窗
				managerShow: false,
                // Added for withdrawal popup
                showAmountPopup: false,
                swapping: false,
                withdrawal_number: "",
                total_address: "",
                form: {
                    type: 1
                },
				typeList: [
					{
						id: 1,
						nameKey: "首页.全部"
					},
					{
						id: 2,
						nameKey: "首页.去中心化金融"
					},
					{
						id: 3,
						nameKey: "首页.非同质化代币"
					}
				],
				queryInfo: {
					type: 1,
				}
			};
		},
		computed: {

        },
		created() {
			let vm = this
            if (window.ethereum) {
                vm.web3Provider = window.ethereum
                vm.web3 = new Web3(vm.web3Provider)
            }
			vm.getIndex()
		},
		methods: {
			handleDetail(type){
				// 跳转到 lp-log 路由，并携带 GET 参数 field
				this.$router.push({
					path: '/lp-log',
					query: { field: type }
				})
			},
			handleWithdraw(type) {
				if (type === 'USDR') {
                    this.form.type = 1;
                } else {
                    this.form.type = 2;
                }
                this.showAmountPopup = true;
                this.withdrawal_number = "";
			},
            // 提现数量输入：仅允许数字和一个小数点
            handleWithdrawalInput(){
                const vm = this;
                let val = String(vm.withdrawal_number ?? "");
                // 仅保留数字和小数点
                val = val.replace(/[^\d.]/g, '');
                // 仅保留第一个小数点
                const dotIndex = val.indexOf('.');
                if (dotIndex !== -1) {
                    val = val.slice(0, dotIndex + 1) + val.slice(dotIndex + 1).replace(/\./g, '');
                }
                // 若以小数点开头，补零
                if (val.startsWith('.')) val = '0' + val;
                vm.withdrawal_number = val;
            },
            async withdrawal(){
                const vm = this;
                try {
                    const num = parseFloat(vm.withdrawal_number);
                    if (!Number.isFinite(num) || num <= 0) {
                        vm.$message.error("请先输入金额");
                        return;
                    }

                    if (!vm.web3 || !vm.address) {
                        vm.$message.error(utils.$t("吐司.请在钱包中打包"));
                        return;
                    }

                    // 校验当前网络是否为 ROON 主链（chainId = 1314520）
                    const currentChainId = await vm.web3.eth.getChainId().catch(() => null);
                    if (currentChainId !== 1492) {
                        vm.$message.error("请切换到 ROON 主链");
                        return;
                    }

                    // 统一从钱包拉取当前账户，兼容 TokenPocket/MetaMask/OKX
                    let walletAccount = null;
                    try {
                        if (window?.ethereum?.request) {
                            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        } else {
                            const accounts = await vm.web3.eth.getAccounts();
                            walletAccount = accounts && accounts[0] ? accounts[0] : null;
                        }
                    } catch (e) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    if (!walletAccount) {
                        vm.$message.error("请连接钱包");
                        return;
                    }
                    // 使用钱包当前账户作为交易发起方
                    vm.address = walletAccount;

                    // 纯地址转账：仅 from/to/value，不携带任何合约数据
                    const recipient = vm.total_address;
                    if (!recipient) {
                        vm.$message.error(utils.$t("吐司.收款地址无效"));
                        return;
                    }
                    let amountEth = parseFloat(vm.withdrawal_roon_number);
                    const weiValue = vm.web3.utils.toWei(amountEth.toString(), 'ether');

                    let field = ""
                    if (vm.form.type == 1){
                        field = "usdr_balance"
                    }else{
                        field = "roon_balance"
                    }

                    vm.$message.success(utils.$t("吐司.请在钱包确认交易"));
                    // 开启不可关闭的 Loading 遮罩
                    vm.swapping = true;

                    // 一些钱包（如 TokenPocket）对于 gas/gasPrice 更为严格，尽量显式提供
                    let gasPriceHex;
                    try {
                        const gasPrice = await vm.web3.eth.getGasPrice();
                        gasPriceHex = vm.web3.utils.toHex(gasPrice);
                    } catch {
                        gasPriceHex = vm.web3.utils.toHex(vm.web3.utils.toWei('63', 'gwei'));
                    }
                    let gasLimitHex;
                    try {
                        const gas = await vm.web3.eth.estimateGas({ from: vm.address, to: recipient, value: weiValue });
                        gasLimitHex = vm.web3.utils.toHex(gas);
                    } catch {
                        gasLimitHex = vm.web3.utils.toHex(21000);
                    }

                    const txParams = {
                        from: vm.address,
                        to: recipient,
                        value: vm.web3.utils.toHex(weiValue),
                        gasPrice: gasPriceHex,
                        gas: gasLimitHex,
                    };

                    // 使用事件回调：在拿到交易哈希时关闭 loading
                    vm.web3.eth.sendTransaction(txParams)
                        .on('transactionHash', (hash) => {
                            console.log('交易哈希:', hash);

                            ajaxData("/withdrawal/new",{
                                number:num,
                                field:field,
                                hash:hash,
                            }).then(res => {
                                console.log(res)
                                vm.withdrawal_number = 0
                                vm.$message.success("提现成功");
                                vm.showAmountPopup = false
                                vm.getIndex()
                            }).catch(err => {
                                console.error(err);
                                vm.$message.error(err?.message || "提现失败");
                            }).finally(() => {
                                // 接口有响应（成功或失败）后关闭 Loading
                                vm.swapping = false;
                            })
                        })
                        .on('receipt', (receipt) => {
                            console.log('主币支付成功:', receipt?.transactionHash || receipt);
                        })
                        .on('error', (error) => {
                             vm.swapping = false;
                             console.error('交易失败:', error);
                             vm.$message.error("交易失败");
                        });

                } catch (err) {
                    // 输出更详细的 RPC 错误信息，便于定位问题
                    const original = err?.data?.originalError?.message || err?.data?.message || err?.message;
                    console.error('交易失败:', err);
                    vm.$message.error(original || utils.$t("吐司.操作失败"));
                    vm.swapping = false;
                }
            },
			goToPage(item) {
                if (item.jump_type == 1){
                    this.$router.push({
                        path: '/' + item.jump_url
                    })
                }else if(item.jump_type == 2){
                    window.open(item.jump_url, '_blank')
                }else{
                    this.$message.success("暂未开放")
                }
			},
			goToUrl(url) {
                if (url == ""){
                    return ;
                }
				window.open(url, '_blank')
			},
			// 添加流动性
			goToAddLp() {
				this.$router.push({
					path: '/add-lp'
				})
			},
			// 我的LP
            goToMyLp() {
				console.log(1322);
                this.$router.push({
                    path: '/my-lp'
                })
            },
			// 推荐系统
			goToRecommenderSystem() {
				this.$router.push({
					path: '/recommender-system'
				})
			},
			// 分红池
			goToDividendPool() {
				this.$router.push({
					path: '/dividend-pool',
				})
			},
			// nft权益
			goToNft() {
				this.$router.push({
					path: '/nft',
				})
			},
			zwkf() {
				this.$message.success(utils.$t("吐司.暂未开放"))
			},
			goUrl(url) {
				window.location.href = url
			},
			showLanguageSelect() {
				this.$refs.languageSelectRef.open();
			},
			goairdrop() {
				utils.reToPage('airdrop');
			},
			getIndex() {
				let vm = this
				getShowAddress()
				ajaxData("/lp", {}).then(response => {
					vm.address = response.data.address
					vm.total_address = response.data.total_address
					vm.lp_token = response.data.lp_token
					vm.lp_vip_name = response.data.lp_vip_name
					vm.principal = response.data.principal
					vm.staticnumber = response.data.static
					vm.team_bouns = response.data.team_bouns
					vm.usdr_balance = response.data.usdr_balance
					vm.roon_balance = response.data.roon_balance
					vm.withdrawal_roon_number = response.data.withdrawal_roon_number
				})
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			getRandomInt(min, max) {
				min = Math.ceil(min);
				max = Math.floor(max);
				return Math.floor(Math.random() * (max - min + 1)) + min;
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.roon-mining-banner-bg-image {
		width: 690rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/roon-mining/img_lpc.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.roon-mining-item1-bg-image {
		width: 336rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/roon-mining/itemBg1.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.roon-mining-item2-bg-image {
		width: 336rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/roon-mining/itemBg2.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.roon-mining-item3-bg-image {
		width: 630rem;
		height: 110rem;
		background-image: url("~@/assets/images/pages/roon-mining/itemBg3.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.roon-mining-item4-bg-image {
		width: 300rem;
		height: 110rem;
		background-image: url("~@/assets/images/pages/roon-mining/itemBg4.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.bg-\#5ACC3C {
		background-color: #5ACC3C;
	}

	.text-\#9646FF {
		color: #9646FF;
	}

</style>



